import '../styles/navbar.css';
import logo from '../media/logo.png';
import { useState } from "react";
import { Menu, X } from "lucide-react"; 


function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
  
    return (
      <header>
        <div className="navbar">
          <div className="logo">
            <img src={logo} alt="Buildege Logo" />
          </div>
  
          {/* Burger Icon for Mobile */}
          <button
            className="burger"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
  
          <nav className={isOpen ? "nav-menu open" : "nav-menu"}>
            <ul>
              <li><a href="#about">About Us</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="/" className="active">Home</a></li>
              <li><a href="#clients">Clients</a></li>
              <li><a href="#contact">Contact Us</a></li>
              <li><a href="#contact" className="btn-header mobile-btn">Consult With Us</a></li>
            </ul>
          </nav>
  
          {/* Desktop CTA Button */}
          <a href="#contact" className="btn-header desktop-btn">Consult With Us</a>
        </div>
      </header>
    );
}

export default Navbar;